import React from 'react';

const Button = ({ children, variant = 'primary', className = '', ...props }) => {
  const baseStyle = "inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variants = {
    primary: "bg-brand-dark text-white hover:bg-brand-primary focus:ring-brand-dark",
    accent: "bg-brand-accent text-brand-dark hover:bg-[#a3d100] focus:ring-brand-accent",
    outline: "border-2 border-brand-dark text-brand-dark hover:bg-brand-light focus:ring-brand-dark",
    ghost: "text-brand-text hover:bg-brand-light hover:text-brand-dark focus:ring-brand-light"
  };

  return (
    <button 
      className={`${baseStyle} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;